/**
 * @generated SignedSource<<8285308408dbb37ea0a0631c0a9a1e95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SidebarHeading_jira$data = {
  readonly hasJsmAdminAccess: boolean | null;
  readonly " $fragmentType": "SidebarHeading_jira";
};
export type SidebarHeading_jira$key = {
  readonly " $data"?: SidebarHeading_jira$data;
  readonly " $fragmentSpreads": FragmentRefs<"SidebarHeading_jira">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "SidebarHeading_jira",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "ScalarField",
      "name": "hasJsmAdminAccess"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "70c016c9c55ec5b845dcf1b13209d267";

export default node;
